import React from 'react'
import './../App.css';

const TextBox = ({content, setContent}) => {
    const handleChange = (e) => {
        setContent( {...content, text: [e.target.value]})
    }
    return(
        <div >
            {/* <h1>Notes</h1> */}
           <textarea className="text-area scroll" value={content.text} onChange={handleChange}>
            </textarea> 
         </div> 
        
    )
}

export default TextBox